import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';


import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { FeiraProvider } from "../../Contexts/FeiraContext";
import MapaVisualizador from '../../Components/Common/MapaIndependente';
import { useFeira } from "../../Contexts/FeiraContext";
import { Link } from "react-router-dom";
import Totalizador from './Totalizador';
import TabelaFiltroPaginacao from "./TabelaFiltroPaginacao";
import { Row, Col } from 'reactstrap';

import {
 TrendingUp,
 CheckCircle,
 Clock,
 Layout,
 RefreshCcw,
 PieChart,
} from 'lucide-react';

ChartJS.register(ArcElement, Tooltip, Legend);

const getNestedValue = (obj, path, defaultValue = null) => {
    if (!path) return defaultValue;
    const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
    return value !== undefined && value !== null ? value : defaultValue;
};

const DashboardEstandes = ({
  estandes,
  mostrarTodosComerciais = true,
  reservas,
  permissao,
  perfil,
  feiraRenovada,
  pavilhoesTotais,
  paises = [],
  estados = [],
  cidades = [],
  pavilhoes = [],
  onFetchEstados = () => {},
  onFetchCidades = () => {},
  feiraSelecionada
}) => {
  const isAdmin = ['JOTAPIX', 'EVOMAP'].includes(perfil);

  const hasPermission = (permissionKey) => {
    if (isAdmin) return true;

    if (!permissao || !Array.isArray(permissao)) return false;


    return permissao.some(p => p.chave === permissionKey);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [filtroCancelados, setFiltroCancelados] = useState('todos');
  const { corLivre, corReservado, corVendido, corRenovacao, corPendenteRenovacao} = useFeira();
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const [filtroComercial, setFiltroComercial] = useState('todos');
  const [statusSelecionado, setStatusSelecionado] = useState('');
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [exportFilters, setExportFilters] = useState({
    vendedor: '',
    periodo: [null, null],
    status: '',
    agruparPor: 'vendedor'
  });
  const [localizacaoTotalizador, setLocalizacaoTotalizador] = useState({
    pais: '',
    estado: '',
    cidade: ''
  });
const mapaRef = useRef(null);
 const [paisSelecionado, setPaisSelecionado] = useState('');
 const [estadoSelecionado, setEstadoSelecionado] = useState('');
 const [cidadeSelecionada, setCidadeSelecionada] = useState('');
 const [pavilhaoSelecionado, setPavilhaoSelecionado] = useState('');
 const [paisTotalizador, setPaisTotalizador] = useState('');
 const [estadoTotalizador, setEstadoTotalizador] = useState('');
 const [cidadeTotalizador, setCidadeTotalizador] = useState('');
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePaisChange = useCallback((value) => {
    setPaisSelecionado(value);
  }, []);

  const handleEstadoChange = useCallback((value) => {
    setEstadoSelecionado(value);
  }, []);

  const handleCidadeChange = useCallback((value) => {
    setCidadeSelecionada(value);
  }, []);

  const handlePavilhaoChange = useCallback((value) => {
    setPavilhaoSelecionado(value);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [filtroStatus, filtroCancelados]);

  useEffect(() => {
    if (paisSelecionado === 'BR') {
      onFetchEstados();
    } else {
      setCidadeSelecionada('');
      setEstadoSelecionado('');
    }
  }, [paisSelecionado, onFetchEstados]);

  useEffect(() => {
    if (estadoSelecionado) {
      onFetchCidades(estadoSelecionado);
    } else {
      setCidadeSelecionada('');
    }
  }, [estadoSelecionado, onFetchCidades]);

  useEffect(() => {
    if (paisTotalizador === 'BR') {
      onFetchEstados();
    } else {
      setEstadoTotalizador('');
    }
  }, [paisTotalizador, onFetchEstados]);

  useEffect(() => {
    if (estadoTotalizador) {
      onFetchCidades(estadoTotalizador);
    } else {
      setCidadeTotalizador('');
    }
  }, [estadoTotalizador, onFetchCidades]);

  const dadosInvalidos = !estandes || !Array.isArray(estandes);
  const reservasInvalidas = !reservas || !Array.isArray(reservas);
  const columns = useMemo(
   () => [
     {
       header: "Nome",
       accessorKey: "nome_estande",
       cell: info => info.getValue() || 'Não informado'
     },
     {
       header: "Pavilhão",
       accessorKey: "pavilhao_nome",
       cell: info => info.getValue() || 'Não informado'
     },
     {
       header: "Área (m²)",
       accessorKey: "area",
       cell: info => info.getValue() || '-',
       size: 50
     },
     {
       header: "Status",
       enableColumnFilter: false,
       accessorKey: "status_reserva_id",
       filterFn: (row, columnId, filterValue) => {
         if (!filterValue) return true;
         const status = getStatus(row.original.status_reserva_id, row.original.cancelado)
         return status.toLowerCase().includes(filterValue.toLowerCase());
       },
       cell: (cell) => {
         const estande = cell.row.original;
         return (
           <span className={`badge ${
             estande.cancelado ? 'bg-secondary' :
             estande.status_reserva_id === 1 ? 'bg-primary' :
             estande.status_reserva_id === 2 ? 'bg-warning' : 
             estande.status_reserva_id === 3 ? 'bg-success' :
             estande.status_reserva_id === 5 ? 'bg-secondary' :
             estande.status_reserva_id === 6 ? 'bg-info' :'bg-success'
           }`}>
             {getStatus(estande.status_reserva_id, estande.cancelado)}
           </span>
         );
       },
     },
     {
       header: "Valor Total",
       accessorKey: "valor_final_para_exportacao",
       enableColumnFilter: false,
       cell: ({ row }) => {
         const estande = row.original;
         const valor = (estande.valor_total_financeiro != null)
           ? estande.valor_total_financeiro
           : estande.valor_total_geral_estande;


         if (estande.valor_total_financeiro === 0)
           return 'R$ 0,00';


         return formatMoney(valor);
       },
       size: 70
     },
     {
       header: "Comercial",
       accessorKey: "comercial",
       cell: info => info.getValue() || 'Nenhum'
     },
     {
       header: "Expositor",
       accessorKey: "expositor_nome",
       cell: info => info.getValue() || 'Nenhum'
     },
     {
       header: "País",
       accessorKey: "expositor_pais",
       cell: info => info.getValue() || '-'
     },
     {
       header: "Estado",
       accessorKey: "expositor_estado",
       cell: info => info.getValue() || '-'
     },
     {
       header: "Cidade",
       accessorKey: "expositor_cidade",
       cell: info => info.getValue() || '-'
     },
   ],
   []
 );

 const totalEstandes = estandes.length;
 const totalArea = estandes.reduce((sum, estande) => sum + (estande.area || 0), 0);
 const valorTotal = estandes.reduce((sum, estande) => sum + (estande.valor_total_geral_estande || 0), 0);
 const estandesVendidos = estandes.filter(e => e.status_reserva_id === 3 && e.cancelado != true);
 const estandesReservados = estandes.filter(e => e.status_reserva_id === 2 && e.cancelado != true);

 const estandesLivres = estandes.filter(e => e.status_reserva_id === 1 && e.cancelado != true);
 const estandesCancelados = estandes.filter(e => e.cancelado === true);
 const estandesRenovados = estandes.filter(e => e.status_reserva_id === 5 && e.cancelado != true);
 const estandesPendenteRenovacao = estandes.filter(e => e.status_reserva_id === 6 && e.cancelado != true);

 const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
 const userData = authUser.user || authUser;
 const userType = userData.tipo || '';
 const reservasComercial = reservas ? ['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType) ? reservas : reservas.filter(e => e.comercial_email === userData.email) : [];

 const valorVendidos = estandesVendidos.reduce((sum, e) => sum + (e.valor_total_geral_estande || 0), 0);
 
 const valorReservados = estandesReservados.reduce((sum, e) => sum + (e.valor_total_geral_estande || 0), 0);
 const valorLivres = estandesLivres.reduce((sum, e) => sum + (e.valor_total_geral_estande || 0), 0);
 const valorRenovados = estandesRenovados.reduce((sum, e) => sum + (e.valor_total_geral_estande || 0), 0) ?? 0;
 const valorPendenteRenovacao = estandesPendenteRenovacao.reduce((sum, e) => sum + (e.valor_total_geral_estande || 0), 0);
 
  let comerciais = [...new Set(
   estandes
     .filter(e => {
     if (['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType)) {
       return e.comercial;
     }

    const estandeEmailNormalized = e.comercial_email?.toLowerCase().trim();
    const userEmailNormalized = userData.email?.toLowerCase().trim();
    
    return estandeEmailNormalized === userEmailNormalized;
   }).map(e => e.comercial)
 )].filter(Boolean);

 useEffect(() => {
   setCurrentPage(1);
 }, [filtroStatus, filtroCancelados]);


 const estandesFiltrados = estandes ? estandes.filter(estande => {
   let porStatus = true;
   if (filtroStatus !== 'todos') {
     if (filtroStatus === '4') { 
       porStatus = estande.cancelado;
     } else {
       porStatus = estande.status_reserva_id === parseInt(filtroStatus) && !estande.cancelado;
     }
   }
  
   let porCancelado = true;
   if (filtroCancelados !== 'todos') {
     porCancelado = filtroCancelados === 'sim' ? estande.cancelado : !estande.cancelado;
   }
  
   return porStatus && porCancelado;
 }) : [];

 const dataGrafico = {
   labels: ['Livres', 'Reservados', 'Vendidos', 'Cancelados', 'Renovados', 'Pendentes Renovação'],
   datasets: [
     {
       data: [
         estandesLivres.length,
         estandesReservados.length,
         estandesVendidos.length,
         estandesCancelados.length,
         estandesRenovados.length,
         estandesPendenteRenovacao.length
       ],
       backgroundColor: [
         corLivre,
         corReservado,
         corVendido,
         '#dc3545',
         corRenovacao,
         corPendenteRenovacao
       ],
       hoverBackgroundColor: [
         corLivre,
         corReservado,
         corVendido,
         '#dc3545',
         corRenovacao,
         corPendenteRenovacao
       ]
     }
   ]
 };

 const StatCard = ({ title, value, money, percent, color, icon: Icon, subText }) => (
   <div style={{
     backgroundColor: '#ffffff',
     borderRadius: '20px',
     padding: '20px',
     border: '1px solid #f1f5f9',
     borderLeft: `6px solid ${color}`,
     boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
     display: 'flex',
     flexDirection: 'column',
     height: '100%'
   }}>
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
       <div style={{ padding: '10px', borderRadius: '12px', backgroundColor: `${color}15`, color: color }}>
         <Icon size={20} />
       </div>
       {percent !== undefined && (
         <span style={{ fontSize: '10px', fontWeight: '900', padding: '4px 8px', borderRadius: '6px', backgroundColor: `${color}15`, color: color }}>
           {percent}%
         </span>
       )}
     </div>
     <p style={{ fontSize: '10px', fontWeight: '800', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0' }}>{title}</p>
     <h4 style={{ fontSize: '24px', fontWeight: '900', color: '#1e293b', margin: 0 }}>
       {value} <span style={{ fontSize: '14px', fontWeight: '500', color: '#94a3b8' }}>{subText}</span>
     </h4>
     <p style={{ fontSize: '13px', fontWeight: '700', color: '#64748b', margin: '4px 0 0 0' }}>{money}</p>
   </div>
 );

 const renderTopCards = () => {
   if (!hasPermission('TOTAL_TOPO') && !isAdmin) return null;
  
   return (
     <div style={{ marginBottom: '32px' }}>

       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '10px', marginBottom: '24px' }}>
         {feiraRenovada && (
           <StatCard
             title="Renovados"
             value={estandesRenovados.length}
             subText="unid."
             money={formatMoney(valorRenovados)}
             percent={totalEstandes > 0 ? (estandesRenovados.length/totalEstandes*100).toFixed(1) : 0}
             color={corRenovacao}
             icon={RefreshCcw}
           />
          
         )}
         {feiraRenovada && (
           <StatCard
             title="Pend.Renovação"
             value={estandesPendenteRenovacao.length}
             subText="unid."
             money={formatMoney(valorPendenteRenovacao)}
             percent={totalEstandes > 0 ? (estandesPendenteRenovacao.length/totalEstandes*100).toFixed(1) : 0}
             color={ corPendenteRenovacao}
             icon={RefreshCcw}
           />
          
         )}
         <StatCard
           title="Vendidos"
           value={estandesVendidos.length}
           subText="unid."
           money={formatMoney(valorVendidos)}
           percent={totalEstandes > 0 ? (estandesVendidos.length/totalEstandes*100).toFixed(1) : 0}
           color={corVendido}
           icon={CheckCircle}
         />
         <StatCard
           title="Reservados"
           value={estandesReservados.length}
           subText="unid."
           money={formatMoney(valorReservados)}
           percent={totalEstandes > 0 ? (estandesReservados.length/totalEstandes*100).toFixed(1) : 0}
           color={corReservado}
           icon={Clock}
         />
         <StatCard
           title="Livres"
           value={estandesLivres.length}
           subText="unid."
           money={formatMoney(valorLivres)}
           percent={totalEstandes > 0 ? (estandesLivres.length/totalEstandes*100).toFixed(1) : 0}
           color={corLivre}
           icon={Layout}
         />
       </div>

       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '10px' }}>

         <div style={{ 
            display: 'grid', 
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '24px', 
            marginBottom: '10px' 
          }}>
            <div style={{ 
              position: 'relative', 
              overflow: 'hidden', 
              borderRadius: '28px', 
              padding: isMobile ? '20px' : '32px', 
              color: '#ffffff', 
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
              boxShadow: '0 10px 25px -5px rgba(16, 185, 129, 0.2)' 
            }}>
              <div style={{ 
                position: 'relative', 
                zIndex: 1, 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row', 
                alignItems: isMobile ? 'flex-start' : 'center' 
              }}>
                <div style={{ 
                  padding: isMobile ? '12px' : '16px', 
                  backgroundColor: 'rgba(255,255,255,0.2)', 
                  borderRadius: '20px', 
                  marginBottom: isMobile ? '12px' : '0',
                  marginRight: isMobile ? '0' : '24px', 
                  backdropFilter: 'blur(10px)' 
                }}>
                  <TrendingUp size={isMobile ? 24 : 36} />
                </div>
                <div>
                  <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1px', opacity: 0.8, margin: '0 0 4px 0' }}>Potencial de Faturamento</p>
                  <h2 style={{ fontSize: isMobile ? '24px' : '36px', fontWeight: '950', margin: 0, lineHeight: 1 }}>{formatMoney(valorTotal)}</h2>
                  <div style={{ marginTop: '8px', fontSize: '14px', fontWeight: '600', opacity: 0.9, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' }}></div>
                    {totalEstandes} espaços mapeados
                  </div>
                </div>
              </div>
              <TrendingUp size={200} style={{ position: 'absolute', right: '-30px', bottom: '-30px', opacity: 0.1, transform: 'rotate(15deg)' }} />
            </div>

            {/* Card 2: Total Efetivado */}
            <div style={{ 
              position: 'relative', 
              overflow: 'hidden', 
              borderRadius: '28px', 
              padding: isMobile ? '20px' : '32px', 
              color: '#ffffff', 
              background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', 
              boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.2)' 
            }}>
              <div style={{ 
                position: 'relative', 
                zIndex: 1, 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row', 
                alignItems: isMobile ? 'flex-start' : 'center' 
              }}>
                <div style={{ 
                  padding: isMobile ? '12px' : '16px', 
                  backgroundColor: 'rgba(255,255,255,0.2)', 
                  borderRadius: '20px', 
                  marginBottom: isMobile ? '12px' : '0',
                  marginRight: isMobile ? '0' : '24px', 
                  backdropFilter: 'blur(10px)' 
                }}>
                  <PieChart size={isMobile ? 24 : 36} />
                </div>
                <div>
                  <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1px', opacity: 0.8, margin: '0 0 4px 0' }}>Total Efetivado (Vendidos)</p>
                  <h2 style={{ fontSize: isMobile ? '24px' : '36px', fontWeight: '950', margin: 0, lineHeight: 1 }}>{formatMoney(valorVendidos)}</h2>
                  <p style={{ marginTop: '8px', fontSize: '14px', fontWeight: '600', opacity: 0.9, margin: 0 }}>
                    {totalEstandes > 0 ? ((estandesVendidos.length)/totalEstandes*100).toFixed(1) : 0}% da meta atingida
                  </p>
                </div>
              </div>
              <PieChart size={200} style={{ position: 'absolute', right: '-30px', bottom: '-30px', opacity: 0.1, transform: 'rotate(-15deg)' }} />
            </div>
          </div>
       </div>
     </div>
   );
 }

 const renderReservasExpiradas = () => {
   if (!hasPermission('RESERVAS') && !isAdmin) return null;
  
   return (
   <>
       {reservasComercial.length > 0 && (hasPermission('RESERVAS') || isAdmin) ? (
         <div className="col-md-12">
           <div className="card">
             <div className="card-header">Reservas expiradas</div>
             <div className="card-body">
               <div className="table-responsive">
                 <table className="table table-sm">
                   <thead>
                     <tr>
                       <th>Estande</th>
                       <th>Comercial</th>
                       <th>Dias</th>
                       <th>Ver</th>
                     </tr>
                   </thead>
                   <tbody>
                     {reservasComercial.map((reserva, index) => {
                       return (
                         <tr key={index}>
                           <td>{reserva.nome_estande}</td>
                           <td>{reserva.nome_comercial}</td>
                           <td>{reserva.dias}</td>
                           <td>
                             <Link to={`/detalhe-reserva/${reserva.id}`} className="btn btn-sm btn-success">
                               Abrir
                             </Link>
                           </td>
                         </tr>
                       );
                     })}
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
         </div>
       ) : null}
     </>
   );
 }

 const renderGraficoStatus = () => {
   if ((!hasPermission('GRAFICO_STATUS')) && !isAdmin) return null;
  
   return (
     <>
       {hasPermission('GRAFICO_STATUS') || isAdmin ? (
         <div className="col-md-5">
           <div className="card">
             <div className="card-header">Distribuição de Estandes</div>
             <div className="card-body">
               <Pie data={dataGrafico} />
             </div>
           </div>
         </div>
       ) : null}
     </>
   );
 };

 const renderTotalComercial = () => {
   if ((!hasPermission('TOTAL_COMERCIAL')) && !isAdmin) return null;
  
   return (
     <>
       {hasPermission('TOTAL_COMERCIAL') || isAdmin ? (
         <div className="col-md-12">
           <div className="card">
             <div className="card-header">Totais por Comercial</div>
             <div className="card-body">
               <div className="table-responsive">
                 <table className="table table-sm">
                   <thead>
                     <tr>
                       <th>Comercial</th>
                       <th>%</th>
                       <th>Vendidos</th>
                      { feiraRenovada && ( <th>Renovados</th>)}
                       <th>Reservados</th>
                      { feiraRenovada && ( <th>Pend.Renov.</th>)}
                       <th>Livres</th>
                       <th>Cancelados</th>
                       <th>Total</th>
                    
                     </tr>
                   </thead>
                   <tbody>
                     {comerciais.map((comercial, index) => {
                       const estandesComercial = estandes.filter(e => e.comercial === comercial);
                       const cancelados = estandesComercial.filter(e => e.cancelado === true).length;
                      
                       return (
                         <tr key={index}>
                           <td>{comercial}</td>
                           <td>{totaisPorComercial[comercial]?.percentual || 0}%</td>
                          
                           <td>{totaisPorComercial[comercial]?.vendidos || 0}</td>
                           { feiraRenovada && ( <td>{totaisPorComercial[comercial]?.renovados || 0}</td>)}
                           <td>{totaisPorComercial[comercial]?.reservados || 0}</td>
                           {feiraRenovada && <td>{totaisPorComercial[comercial]?.pendentes}</td>}
                           <td>{totaisPorComercial[comercial]?.livres || 0}</td>
                           <td>{cancelados}</td>
                           <td>{totaisPorComercial[comercial]?.total || 0}</td>
                          
                         </tr>
                       );
                     })}
                   </tbody>
                 </table>
               </div>
             </div>
           </div>
         </div>
       ) : null}
     </>
   );
 };

 const renderTotalPavilhao = () => {
  
   if (!hasPermission("PAVILHOES")) return null;


   const totais = pavilhoesTotais.reduce((acc, pavilhao) => {
     acc.total_estandes += Number(pavilhao.total_estandes) || 0;
     acc.metragem_ocupada_m2 += Number(pavilhao.metragem_ocupada_m2) || 0;
     acc.total_expositores += Number(pavilhao.total_expositores) || 0;
     acc.metragem_locavel_m2 += Number(pavilhao.metragem_locavel_m2) || 0;
     acc.metragem_nao_locavel_m2 += Number(pavilhao.metragem_nao_locavel_m2) || 0;
     return acc;
   }, {
     total_estandes: 0,
     metragem_ocupada_m2: 0,
     total_expositores: 0,
     metragem_locavel_m2: 0,
     metragem_nao_locavel_m2: 0
   });


   return (
     <>
       {hasPermission('PAVILHOES') || isAdmin ? (
         <div className="col-md-12">
           <div className="card">
             <div className="card-header">Pavilhões</div>
             <div className="card-body">
               <div className="table-responsive">
                 <table className="table table-sm">
                   <thead>
                     <tr>
                       {/* Alinhamento adicionado aos cabeçalhos */}
                       <th className="text-start">Pavilhão</th>
                       <th className="text-end">Espaços</th>
                       <th className="text-end">Expositores</th>
                       <th className="text-end">Espaços m²</th>
                       <th className="text-end">Expositores m²</th>
                     </tr>
                   </thead>
                   <tbody>
                     {pavilhoesTotais.map((pavilhao, index) => (
                       <tr key={index}>
                         {/* Alinhamento adicionado às células de dados */}
                         <td className="text-start">{pavilhao.nome_pavilhao}</td>
                         <td className="text-end">{pavilhao.total_estandes}</td>
                         <td className="text-end">{pavilhao.total_expositores}</td>
                         <td className="text-end">{formatNumber(pavilhao.metragem_locavel_m2)}</td>
                         <td className="text-end">{formatNumber(pavilhao.metragem_ocupada_m2)}</td>
                       </tr>
                     ))}
                   </tbody>
                   <tfoot>
                     <tr style={{ fontWeight: 'bold' }}>
                       <td className="text-start">TOTAL</td>
                       <td className="text-end">{totais.total_estandes}</td>
                       <td className="text-end">{totais.total_expositores}</td>
                       <td className="text-end">{formatNumber(totais.metragem_locavel_m2.toFixed(2))}</td>
                       <td className="text-end">{formatNumber(totais.metragem_ocupada_m2.toFixed(2))}</td>
                      
                     </tr>
                   </tfoot>
                 </table>
               </div>
             </div>
           </div>
         </div>
       ) : null}
     </>
   );
 };

  const processedData = useMemo(() => {
   if (!estandes || !Array.isArray(estandes)) return [];
  
   return estandes.map(estande => ({
     ...estande,
     nome_estande: estande.nome_estande || 'Não informado',
     expositor_nome: estande.expositor_nome || 'Nenhum',
     comercial: estande.comercial || 'Nenhum',
     comercial_email: estande.comercial_email || 'Nenhum',
     valor_final_para_exportacao: (estande.valor_total_financeiro != null) ? estande.valor_total_financeiro : estande.valor_total_geral_estande
   }));
 }, [estandes]);

 const dadosFiltradosPorPerfil = useMemo(() => {
     if (['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(perfil)) {
       return processedData;
     }


   if (perfil === 'COMERCIAL') {
       const userEmailNormalized = userData.email?.toLowerCase().trim(); 
      
       return processedData.filter(estande => {
         const estandeEmailNormalized = estande.comercial_email?.toLowerCase().trim();


         return estandeEmailNormalized === userEmailNormalized;
       });
     }


     return [];
   }, [processedData, perfil]);

 const dadosFiltradosComLocalizacao = useMemo(() => {
   let filtered = dadosFiltradosPorPerfil;

   if (statusSelecionado) {
    if (statusSelecionado === 'cancelado') {
      filtered = filtered.filter(item => item.cancelado === true);
    } else {
      filtered = filtered.filter(item => 
        item.status_reserva_id === parseInt(statusSelecionado) && !item.cancelado
      );
    }
  }

   if (paisSelecionado) {
     filtered = filtered.filter(item => item.expositor_pais === paisSelecionado);
   }

   if (estadoSelecionado) {
     filtered = filtered.filter(item => item.expositor_estado === estadoSelecionado);
   }

   if (cidadeSelecionada) {
     filtered = filtered.filter(item => item.expositor_cidade === cidadeSelecionada);
   }

   if (pavilhaoSelecionado) {
     filtered = filtered.filter(item => item.pavilhao_nome === pavilhaoSelecionado);
   }

   return filtered;
 }, [dadosFiltradosPorPerfil, statusSelecionado, paisSelecionado, estadoSelecionado, cidadeSelecionada, pavilhaoSelecionado]);


 const totaisGerais = useMemo(() => {
    const dados = dadosFiltradosComLocalizacao;
    if (!dados || dados.length === 0) return null;

    let dadosParaCalculo = dados;
    if (localizacaoTotalizador.pais || localizacaoTotalizador.estado || localizacaoTotalizador.cidade) {
      dadosParaCalculo = dados.filter(item => {
        const matchPais = !localizacaoTotalizador.pais || item.expositor_pais === localizacaoTotalizador.pais;
        const matchEstado = !localizacaoTotalizador.estado || item.expositor_estado === localizacaoTotalizador.estado;
        const matchCidade = !localizacaoTotalizador.cidade || item.expositor_cidade === localizacaoTotalizador.cidade;
        return matchPais && matchEstado && matchCidade;
      });
    }

  const estandesConsiderados = dadosParaCalculo.filter(e => e.status_reserva_id === 3 && !e.cancelado);
  const espacosReservados = dadosParaCalculo.filter(e => e.status_reserva_id === 2 && !e.cancelado).length;
  const espacosRenovados = dadosParaCalculo.filter(e => e.status_reserva_id === 5 && !e.cancelado).length;
  const espacosPendenteRenovacao = dadosParaCalculo.filter(e => e.status_reserva_id === 6 && !e.cancelado).length;
  const totalEspacos = dados.length;
  const espacosVendidos = estandesConsiderados.length;
  const faltam = totalEspacos - espacosVendidos - espacosReservados;
  const metragemTotal = dados.reduce((sum, item) => sum + (item.area || 0), 0);
  const metragemVendida = estandesConsiderados.reduce((sum, item) => sum + (item.area || 0), 0);
  const metragemBonificada = estandesConsiderados.reduce((sum, item) => sum + (item.metragem_bonificada || 0), 0);
  const valorTotalVendido = estandesConsiderados.reduce((sum, item) => sum + (item.valor_final_calculado || 0), 0);
  
  const valorEspaco = estandesConsiderados.reduce((sum, item) => sum + (item.valor_total_estande_metro || 0), 0);
  const valorKVA = estandesConsiderados.reduce((sum, item) => sum + (item.valor_kva_tabela || 0), 0);
  const valorEstacionamento = estandesConsiderados.reduce((sum, item) => sum + (item.valor_estacionamento || 0), 0);
  const totaisAdicionais = estandesConsiderados.reduce((acc, item) => {
      if (Array.isArray(item.adicionais_detalhados)) {
           item.adicionais_detalhados.forEach(adicional => {
               const nome = adicional.nome?.trim().toLowerCase() || 'outro';
               acc[nome] = (acc[nome] || 0) + (adicional.valor || 0);
           });
       }
       return acc;
   }, {});

    const metragemRenovada = estandesConsiderados.filter(item => item.status_reserva_id === 5).reduce((sum, item) => sum + (getNestedValue(item, 'area', 0) || 0), 0); // Adicionado: Metragem Livre
    const metragemPendenteRenovacao= estandesConsiderados.filter(item => item.status_reserva_id === 6).reduce((sum, item) => sum + (getNestedValue(item, 'area', 0) || 0), 0); // Adicionado: Metragem Livre

    const metragemLivre = estandesConsiderados.filter(item => item.status_reserva_id === 1).reduce((sum, item) => sum + (getNestedValue(item, 'area', 0) || 0), 0); // Adicionado: Metragem Livre
    const metragemReservada = estandesConsiderados.filter(item => item.status_reserva_id === 2).reduce((sum, item) => sum + (getNestedValue(item, 'area', 0) || 0), 0); // Adicionado: Metragem Reservada

    const metragemCobrada = metragemVendida - metragemBonificada;
    const quantidadeKVA = estandesConsiderados.reduce((sum, item) => sum + (getNestedValue(item, 'quantidade_kva_tabela', 0) || 0), 0);
    const quantidadeEstacionamento = estandesConsiderados.reduce((sum, item) => sum + (getNestedValue(item, 'quantidade_estacionamento', 0) || 0), 0);

   const dadosChapeco = estandesConsiderados.filter(e => e.expositor_cidade?.toLowerCase() === 'chapecó');
   const clientesChapeco = dadosChapeco.length;
   const metragemChapeco = dadosChapeco.reduce((sum, item) => sum + (item.area || 0), 0);
   const valorChapeco = dadosChapeco.reduce((sum, item) => sum + (item.valor_final_calculado || 0), 0);

     return {
         totalEspacos,
         espacosVendidos,
         faltam,
         espacosReservados,
         espacosPendenteRenovacao,
         espacosRenovados,
         metragemTotal,
         metragemVendida,
         metragemBonificada,
         metragemCobrada: metragemVendida - metragemBonificada,
         percentualVendido: totalEspacos > 0 ? (espacosVendidos / totalEspacos) * 100 : 0,
         valorTotalVendido,
         valorEspaco,
         valorKVA,
         valorEstacionamento,
         valorLimpeza: totaisAdicionais['taxa limpeza'] || 0,
         valorMerchan: totaisAdicionais['merchan'] || 0, 
         chapeco: {
             clientes: clientesChapeco,
             metragem: metragemChapeco,
             valor: valorChapeco,
             percentualClientes: espacosVendidos > 0 ? (clientesChapeco / espacosVendidos) * 100 : 0,
             percentualMetragem: metragemVendida > 0 ? (metragemChapeco / metragemVendida) * 100 : 0,
             percentualValor: valorTotalVendido > 0 ? (valorChapeco / valorTotalVendido) * 100 : 0,
         },
        metragemRenovada,
        metragemPendenteRenovacao,
        metragemLivre,
        metragemReservada,
        metragemCobrada,
        quantidadeKVA,
        quantidadeEstacionamento
     };
 }, [dadosFiltradosComLocalizacao, localizacaoTotalizador]);

 const renderEstandesTable = () => {
  
   if (!hasPermission('LISTA_ESTANDES') && !isAdmin) return null;
   return (
      <div className="card">
       <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
         <span>Lista de Espaços ({estandesFiltrados.length})</span>
       </div>
        <div className="card-body">
         <TabelaFiltroPaginacao
            columns={columns}
            data={dadosFiltradosComLocalizacao}
            isGlobalFilter={true}
            customPageSize={10}
            tableClassName="align-middle"
            theadClassName="table-light text-muted"
            divClassName="table-responsive table-card mb-1"
            SearchPlaceholder="Pesquise ..."
            nomeRelatorio='Relatório de Espaços'
            dashboard={true}
            feiraRenovada={feiraRenovada}
            statusSelecionado={statusSelecionado}
            onStatusChange={setStatusSelecionado}
            filters={[
              {
                column: "status",
                options: ["Livre", "Reservado", "Vendido", "Cancelado", "Renovado"]
              }
            ]}
            statusOptions={['Livre', 'Reservado', 'Vendido', 'Cancelado', 'Renovado']}
            paisesOptions={paises}
            paisSelecionado={paisSelecionado}
            onPaisChange={handlePaisChange}
            estadosOptions={estados}
            estadoSelecionado={estadoSelecionado}
            onEstadoChange={handleEstadoChange}
            cidadesOptions={cidades}
            cidadeSelecionada={cidadeSelecionada}
            onCidadeChange={handleCidadeChange}
            pavilhoesOptions={pavilhoes}
            pavilhaoSelecionado={pavilhaoSelecionado}
            onPavilhaoChange={handlePavilhaoChange}
            getStatus={(statusId, cancelado) => {
              if (cancelado) return 'Cancelado';
              switch(statusId) {
                case 2: return 'Reservado';
                case 3: return 'Vendido';
                case 4: return 'Livre';
                case 5: return 'Renovado';
                case 6: return 'Pend.Renovação';
                default: return 'Cancelado';
              }
            }}
         />
       </div>
     </div>
   );
 };

const renderMapaExportacao = () => {
  if (!hasPermission('EXPORTACAO') && !isAdmin) return null;

  return (
    <div className="card mt-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <span>Mapa da Feira</span>
        <div className="d-flex gap-2">
          <button 
            className="btn btn-primary btn-sm"
            onClick={() => mapaRef.current?.exportImage()}
          >
            Baixar Imagem (PNG)
          </button>
          <button 
            className="btn btn-danger btn-sm"
            onClick={() => mapaRef.current?.exportPDF()}
          >
            Baixar PDF
          </button>
        </div>
      </div>
      <div className="card-body" style={{ height: '700px', position: 'relative' }}>
        <FeiraProvider idFeira={feiraSelecionada}>
          <MapaVisualizador ref={mapaRef} />
        </FeiraProvider>
      </div>
    </div>
  );
};

 const totaisPorComercial = comerciais.reduce((acc, comercial) => {
 const estandesComercial = estandes.filter(e => e.comercial === comercial);
 const vendidos = estandesComercial.filter(e => e.status_reserva_id === 3 && !e.cancelado).length;
 const reservados = estandesComercial.filter(e => e.status_reserva_id === 2 && !e.cancelado).length;
 const livres = estandesComercial.filter(e => e.status_reserva_id === 1 && !e.cancelado).length;
 const renovados = estandesComercial.filter(e => e.status_reserva_id === 5 && !e.cancelado).length;
 const cancelados = estandesComercial.filter(e => e.cancelado).length;
 const pendentes = estandesComercial.filter(e => e.status_reserva_id === 6 && !e.cancelado).length;
 
  acc[comercial] = {
   total: estandesComercial.length,
   vendidos,
   reservados,
   livres,
   cancelados,
   renovados,
   pendentes,
   percentual: totalEstandes > 0 ? (estandesComercial.length / totalEstandes * 100).toFixed(2) : 0
 };
 return acc;
}, {});

 const totaisFiltrados = useMemo(() => {
   const dados = dadosFiltradosComLocalizacao; 
  
   if (!dados || dados.length === 0 || (!paisTotalizador && !estadoTotalizador && !cidadeTotalizador)) {
       return null;
   }


   const dadosParaCalculo = dados.filter(item => {
       const matchPais = !paisTotalizador || item.expositor_pais === paisTotalizador;
       const matchEstado = !estadoTotalizador || item.expositor_estado === estadoTotalizador;
       const matchCidade = !cidadeTotalizador || item.expositor_cidade === cidadeTotalizador;
       return matchPais && matchEstado && matchCidade;
   });


   if (dadosParaCalculo.length === 0) return { clientes: 0, metragem: 0, valor: 0, percentualClientes: 0, percentualMetragem: 0, percentualValor: 0 };
  
   const estandesConsiderados = dadosParaCalculo.filter(e => e.status_reserva_id !== 1 && e.status_reserva_id !== 6 && !e.cancelado);
   const clientesLocalizacao = estandesConsiderados.length;
   const metragemLocalizacao = estandesConsiderados.reduce((sum, item) => sum + (item.area || 0), 0);
   const valorLocalizacao = estandesConsiderados.reduce((sum, item) => sum + (item.valor_final_calculado || 0), 0);


   return {
       clientes: clientesLocalizacao,
       metragem: metragemLocalizacao,
       valor: valorLocalizacao,
       percentualClientes: totaisGerais.espacosVendidos > 0 ? (clientesLocalizacao / totaisGerais.espacosVendidos) * 100 : 0,
       percentualMetragem: totaisGerais.metragemVendida > 0 ? (metragemLocalizacao / totaisGerais.metragemVendida) * 100 : 0,
       percentualValor: totaisGerais.valorTotalVendido > 0 ? (valorLocalizacao / totaisGerais.valorTotalVendido) * 100 : 0,
   };
   
 }, [dadosFiltradosComLocalizacao, paisTotalizador, estadoTotalizador, cidadeTotalizador, totaisGerais]);

 const renderTotalizador = () => {
   if (!hasPermission('TOTALIZADOR')) return null;
  
   return (
     <div className="row">
       <div className="col-lg-12">
         <Totalizador
           totaisGerais={totaisGerais}
           totaisFiltrados={totaisFiltrados}
           feiraRenovada={feiraRenovada}
           
           paisesOptions={paises}
           estadosOptions={estados}
           cidadesOptions={cidades}

           paisSelecionado={paisTotalizador}
           onPaisChange={setPaisTotalizador}
          
           estadoSelecionado={estadoTotalizador}
           onEstadoChange={setEstadoTotalizador}
          
           cidadeSelecionada={cidadeTotalizador}
           onCidadeChange={setCidadeTotalizador}

           corLivre={corLivre}
            corRenovacao={corRenovacao}
            corPendenteRenovacao={corPendenteRenovacao}
            corReservado={corReservado}
            corVendido={corVendido}
         />
       </div>
     </div>
   );
 }
 const getStatus = (statusId, isCanceled) => {
 if (isCanceled) return 'Cancelado';
  switch(statusId) {
   case 1: return 'Livre';
   case 2: return 'Reservado';
   case 3: return 'Vendido';
   case 5: return 'Renovado';
   case 6: return 'Pend.Renovação';
   default: return 'Desconhecido';
 }
};

 const formatMoney = (value) => {
   if (value === null || value === undefined || value === 0) return 'R$ --';
   return new Intl.NumberFormat('pt-BR', {
     style: 'currency',
     currency: 'BRL'
   }).format(value || 0);
 };

 const formatNumber = (value) => {
   if (value === null || value === undefined) return '0,00';
     return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value || 0);
 };

 return (
   <div className="mt-4">
     {dadosInvalidos && (
       <div className="alert alert-info">Nenhum dado de espaço disponível</div>
     )}


     {reservasInvalidas && (
       <div className="alert alert-info">Nenhuma reserva expirada</div>
     )}


     {!dadosInvalidos && !reservasInvalidas  && (
       <>
         {renderTopCards()}
         {renderReservasExpiradas()}
         <div className="row mb-4">
           {renderGraficoStatus()}
           <Col md={7}>
             <Row>
               {renderTotalPavilhao()}
               {renderTotalComercial()}
             </Row>
             </Col>
         </div>

         {renderTotalizador()}
        
         {renderEstandesTable()}
         {renderMapaExportacao()}
       </>
     )}
   </div>
 );
};


export default DashboardEstandes;